import { gql } from "lib/apolloClient";
import {
  organizationResourceFeedFragment,
  organizationChildResourceFragment,
} from "./LeFeedFragment";
import { userFragment } from "modules/CommonFragments";

export const getOrganizationResourcesFeedQueryV2 = gql`
  query getOrganizationResourcesFeedV2(
    $parentId: ID!
    $searchText: String
    $parentType: ENTITY_TYPE_ENUM!
    $after: String
  ) {
    node(id: $parentId, type: $parentType) {
      id
      ... on UnitPlan {
        ...unitPlanResourceFeedItemV2
      }
    }
  }
  ${organizationResourceFeedFragment.unitPlanResourceFeedV2}
`;

export const getChildResourcesFeedQueryV2 = gql`
  query getChildResourcesFeedV2(
    $id: ID!
    $first: Int
    $after: String
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $filters: OrganizationResourceFilter
  ) {
    node(id: $id, type: ORGANIZATION_RESOURCE) {
      ...organizationChildResourceItemV2
    }
  }
  ${organizationChildResourceFragment.childResourceFragmentV2}
`;

export const getLELibraryFeedQuery = gql`
  query getLELibraryFeed(
    $id: ID!
    $filters: AssessmentOrganizationFilters
    $after: String
    $userArchivedFilters: UserArchivedFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        assessments(first: 16, filters: $filters, after: $after) {
          totalCount
          edges {
            node {
              id
              title {
                id
                value
              }
              image {
                id
                value
              }
              assessmentType {
                id
                value
              }
              taskType {
                id
                type
                label
              }
              type
              assessmentToolType
              createdBy {
                isArchivedV2(filters: $userArchivedFilters)
                ...userItem
              }
              createdAt
              grades {
                id
                name
              }
              unitPlan {
                id
              }
              assessmentTools {
                edges {
                  node {
                    id
                    assessmentToolItem {
                      id
                      ... on CommentAssessmentTool {
                        id
                      }
                      ... on ScoreAssessmentTool {
                        id
                        scoreToolData {
                          id
                          maxScore
                        }
                      }
                    }
                    assessmentToolType
                  }
                }
              }
              organizationResourcesV2(
                first: null
                filters: { types: WORKSHEET_RESOURCE, resourceTypes: FOLDER }
              ) {
                resourceTypeBasedCount {
                  totalCount
                  questionStatusWiseCount {
                    status
                    count
                  }
                  questionTypeWiseCount {
                    questionTypeUid
                    count
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${userFragment.basicUser}
`;
